import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Api } from './api';
import { DashboardPanel } from '../models/dashboard-panel.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DashboardPanelService {
  private endpoint = '/dashboard-panels';

  constructor(private api: Api) {}

  getDashboardPanels(
    page: number = 0,
    size: number = 20,
    sort: string = 'id,asc'
  ): Observable<DashboardPanel[]> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sort,
    };
    return this.api.get(this.endpoint, params);
  }

  getDashboardPanelById(id: number): Observable<DashboardPanel> {
    return this.api.get(`${this.endpoint}/${id}`);
  }

  createDashboardPanel(panel: Partial<DashboardPanel>): Observable<DashboardPanel> {
    return this.api.post(this.endpoint, panel);
  }

  updateDashboardPanel(id: number, panel: Partial<DashboardPanel>): Observable<DashboardPanel> {
    return this.api.putGenerate(`${this.endpoint}/${id}`, panel);
  }

  deleteDashboardPanel(id: number): Observable<void> {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  getAllDashboardPanels(): Observable<DashboardPanel[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<DashboardPanel[]>(this.endpoint, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<DashboardPanel[]>) => response.body || [])
    );
  }

  getDashboardPanelsByQueryId(queryId: number): Observable<DashboardPanel[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<DashboardPanel[]>(`${this.endpoint}?queryId.equals=${queryId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<DashboardPanel[]>) => response.body || [])
    );
  }

  getDashboardPanelsByDataSourceId(datasourceId: number): Observable<DashboardPanel[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<DashboardPanel[]>(`${this.endpoint}?datasourceId.equals=${datasourceId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<DashboardPanel[]>) => response.body || [])
    );
  }

  getDashboardPanelsByDataStoreId(dataStoreId: number): Observable<DashboardPanel[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<DashboardPanel[]>(`${this.endpoint}?dataStoreId.equals=${dataStoreId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<DashboardPanel[]>) => response.body || [])
    );
  }

  countDashboardPanels(): Observable<number> {
    return this.api.get(`${this.endpoint}/count`);
  }
} 